<template>
  <NuxtLayout name="error">
    <TemplateError />
  </NuxtLayout>
</template>

<script setup lang="ts">
import { useTranslationStore } from '~/store/translation'
import { useI18n } from 'vue-i18n'

interface Props {
  error: object
}

defineProps<Props>()

const i18n = useI18n()
const translationStore = useTranslationStore()
const locale = i18n.locale.value

await useAsyncData(`translations:${locale}`, async () => await translationStore.load({ locale }))
i18n.mergeLocaleMessage(translationStore.locale, translationStore.translations)
</script>

<style>
.page-enter-active,
.page-leave-active {
  transition: all 0.2s;
}
.page-enter-from,
.page-leave-to {
  opacity: 0;
  filter: opacity(50%);
}
</style>
